/** Rail labels that must resolve to a line-art glyph, shared with tests. */
export const RAIL_ICON_LABELS = [
  "Orientation",
  "Research verdict",
  "Four fields",
  "Proposition",
  "Lexicon",
  "Recognition",
  "Gift & limit",
  "Declaration",
  "Mandate",
  "The room",
  "Case method",
  "Threshold",
  "Assessment",
  "Refusals",
  "Contrast",
  "Shared ground",
  "Correction",
  "Reality check",
  "Premise",
  "Architecture",
  "Commons",
  "Decisions",
  "Proof",
  "Position",
  "Offers",
  "Fit",
  "Narrative",
  "90 days",
  "Message",
  "Naming",
  "Evidence grammar",
  "Core texts",
  "Planetary condition",
  "Transition lineages",
  "Rights & legitimacy",
  "Open questions",
] as const;

export const SPINE_ICON_LABELS = ["Bound", "See", "Choose", "Shift", "Learn"] as const;
